export const getShopIdWhenAllowed = (shopId: number | undefined, isAllowed: boolean): number | undefined => {
  const allowedShopId = (isAllowed && shopId) || undefined;

  return allowedShopId;
};

export const countOrZero = (count: number | undefined): number => {
  const definedCount = count || 0;

  return definedCount;
};
